module.exports = __webpack_public_path__ + "assets/img/share-title.27fdbe3c.png";